// Armonia — scroll reveal. O singură dată per element, stagger scurt pe grile.
// Notă: elementele cu clip-path total au intersectionRect gol (Chrome) și nu declanșează
// IntersectionObserver — de aceea cortinele (.rv-img) sunt observate prin PĂRINTELE lor.
(function(){
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var RISE = 'h2,.pagehead,.prod,.rcard,.quote,.convcard,.info,.thumbs,.fnews,.shin>div';
  var CURTAIN = '.shin>img';

  var rises = [].slice.call(document.querySelectorAll(RISE));
  rises.forEach(function(el){ el.classList.add('rv'); });

  var proxies = [];
  [].slice.call(document.querySelectorAll(CURTAIN)).forEach(function(el){
    el.classList.add('rv-img');
    var proxy = el.parentElement || el;
    proxy.__curtain = el;
    proxies.push(proxy);
  });

  var io = new IntersectionObserver(function(entries){
    entries.filter(function(e){ return e.isIntersecting; })
      .forEach(function(e, i){
        var target = e.target.__curtain || e.target;
        target.style.transitionDelay = Math.min(i*60, 240) + 'ms';
        target.classList.add('in');
        io.unobserve(e.target);
      });
  }, { rootMargin: '0px 0px -60px 0px', threshold: 0.06 });

  rises.concat(proxies).forEach(function(el){ io.observe(el); });
})();
